<!-- @veltra/icons generated sha256:64979963b9c5fe7a gen:8 source:src/svg/normal/form-multi-tree-select.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormMultiTreeSelect' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="1.2"
      d="M3 2v12m0-8h3m-3 5h3"
    />
    <rect width="3" height="3" x="7" y="4.5" fill="none" stroke="currentColor" rx=".5" />
    <rect width="3" height="3" x="7" y="9.5" fill="none" stroke="currentColor" rx=".5" />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.2"
      d="m12.5 7.5 1 1 1-1"
    />
  </svg>
</template>
